/**
 * Gerenciador de Ciclo de Sessão em SPA e Terminais Compartilhados da MeMed.
 * Permite alternar o prescritor em runtime sem reload e limpar caches e rascunhos no logout.
 */
export function alternarPrescritorEmSPA(novoTokenJWT: string): void {
  if (typeof window !== 'undefined') {
    const sinapse = (window as any).MdSinapsePrescricao;
    if (sinapse?.setToken) {
      sinapse.setToken(novoTokenJWT);
      console.info('[Medikei] Sessão da MeMed atualizada para o novo prescritor em runtime.');
    }
  }
}

export async function encerrarSessaoTerminalCompartilhado(): Promise<void> {
  if (typeof window === 'undefined') return;

  try {
    if ((window as any).MdHub?.command?.send) {
      await (window as any).MdHub.command.send('plataforma.sdk', 'logout');
      console.info('[Medikei] LocalStorage e credenciais da MeMed limpos com sucesso.');
    }
  } catch (error) {
    console.warn('[Medikei] Aviso ao executar logout do SDK MeMed:', error);
  }
}
